var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 30,
    viewBox: "0 0 21 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3 27.8571C6.3 28.4255 6.07875 28.9705 5.68492 29.3724C5.2911 29.7742 4.75695 30 4.2 30H2.1C1.54305 30 1.0089 29.7742 0.615076 29.3724C0.22125 28.9705 0 28.4255 0 27.8571V2.14286C0 1.57454 0.22125 1.02949 0.615076 0.627629C1.0089 0.225765 1.54305 0 2.1 0H4.2C4.75695 0 5.2911 0.225765 5.68492 0.627629C6.07875 1.02949 6.3 1.57454 6.3 2.14286V27.8571ZM21 27.8571C21 28.4255 20.7788 28.9705 20.3849 29.3724C19.9911 29.7742 19.457 30 18.9 30H16.8C16.243 30 15.7089 29.7742 15.3151 29.3724C14.9212 28.9705 14.7 28.4255 14.7 27.8571V2.14286C14.7 1.57454 14.9212 1.02949 15.3151 0.627629C15.7089 0.225765 16.243 0 16.8 0H18.9C19.457 0 19.9911 0.225765 20.3849 0.627629C20.7788 1.02949 21 1.57454 21 2.14286V27.8571Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.2b13fb07477d242c8f6e3e282728b0ee.svg";
export { ForwardRef as ReactComponent };